import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ResendCodeProps {
  timer: number;
  resendEnabled: boolean;
  resendCode: () => void;
  maxResendsReached?: boolean;
}

const ResendCode: React.FC<ResendCodeProps> = ({ timer, resendEnabled, resendCode, maxResendsReached }) => {
  const { t } = useTranslation();

  if (maxResendsReached) {
    return (
      <div className="mt-3">
        <span className="text-danger">
          {t('common.max_resends_reached', 'Maximum resend attempts reached. Please contact support.')}
        </span>
      </div>
    );
  }

  return (
    <div className="mt-3">
      {t('common.didnt_receive')}{' '}
      {resendEnabled ? (
        <Link className="text-primary" to="" onClick={resendCode}>
          {t('common.resend_code')}
        </Link>
      ) : (
        <span>
          {t('common.try_again_in', 'Try again in')} <span className="text-primary">{timer}s</span>
        </span>
      )}
    </div>
  );
};

export default ResendCode;
